// extracted by mini-css-extract-plugin
export default {"root":"CreateEditAttendee_root__mXHIX"};